import { useCurrentEditor } from '@tiptap/react';
import { EditorButton } from './buttons';
import { Icon } from '../../icon';
import React from 'react';
import { Tooltip } from '../../tooltip';
export function Link() {
    const { editor } = useCurrentEditor();
    if (!editor) {
        return null;
    }
    const disabled = !editor.isEditable;
    const isActive = !disabled && editor.isActive('link');
    function setLink() {
        const previousUrl = editor.getAttributes('link').href;
        const url = window.prompt('URL', previousUrl);
        // cancelled
        if (url === null) {
            return;
        }
        // empty
        if (url === '') {
            editor.chain().focus().extendMarkRange('link').unsetLink().run();
            return;
        }
        editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
    }
    return (React.createElement(Tooltip, { content: "Link", disabled: disabled },
        React.createElement(EditorButton, { StartIcon: React.createElement(Icon, { name: "attachment" }), onClick: setLink, isActive: isActive, disabled: disabled || !editor.can().chain().focus().toggleMark('link').run() })));
}
